import { createPlugin, createApiFactory, discoveryApiRef, identityApiRef, createRoutableExtension, createComponentExtension } from '@backstage/core-plugin-api';
import { rootRouteRef, scorecardsRouteRef, scorecardRouteRef } from './routes.esm.js';
import { cortexApiRef, CortexClient } from './api/CortexClient.esm.js';
import { NoopExtensionClient } from './api/NoopExtensionClient.esm.js';
import { extensionApiRef } from './api/ExtensionApi.esm.js';

const cortexPlugin = createPlugin({
  id: "cortex",
  apis: [
    createApiFactory({
      api: cortexApiRef,
      deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
      factory: ({ discoveryApi, identityApi }) => new CortexClient({ discoveryApi, identityApi })
    }),
    createApiFactory({
      api: extensionApiRef,
      deps: {},
      factory: () => new NoopExtensionClient()
    })
  ],
  routes: {
    root: rootRouteRef,
    scorecards: scorecardsRouteRef,
    scorecard: scorecardRouteRef
  }
});
const extendableCortexPlugin = (deps, factory = () => new NoopExtensionClient()) => {
  const plugin = createPlugin({
    id: "cortex",
    apis: [
      createApiFactory({
        api: cortexApiRef,
        deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
        factory: ({ discoveryApi, identityApi }) => new CortexClient({ discoveryApi, identityApi })
      }),
      createApiFactory({
        api: extensionApiRef,
        deps,
        factory
      })
    ],
    routes: {
      root: rootRouteRef,
      scorecards: scorecardsRouteRef,
      scorecard: scorecardRouteRef
    }
  });
  const CortexPage2 = plugin.provide(
    createRoutableExtension({
      name: "CortexPage",
      component: () => import('./components/CortexPage/index.esm.js').then((m) => m.CortexPage),
      mountPoint: rootRouteRef
    })
  );
  const EntityCortexContent2 = plugin.provide(
    createComponentExtension({
      name: "EntityCortexContent",
      component: {
        lazy: () => import('./components/EntityPage/index.esm.js').then((m) => m.EntityPage)
      }
    })
  );
  const CortexScorecardWidget2 = plugin.provide(
    createComponentExtension({
      name: "CortexScorecardWidget",
      component: {
        lazy: () => import('./components/CortexScorecardWidget/index.esm.js').then(
          (m) => m.CortexScorecardWidget
        )
      }
    })
  );
  const CortexGroupActionItemsWidget2 = plugin.provide(
    createComponentExtension({
      name: "CortexGroupActionItemsWidget",
      component: {
        lazy: () => import('./components/CortexGroupActionItemsWidget/index.esm.js').then(
          (m) => m.CortexGroupActionItemsWidget
        )
      }
    })
  );
  const SystemCortexContent2 = plugin.provide(
    createComponentExtension({
      name: "SystemCortexContent",
      component: {
        lazy: () => import('./components/SystemPage/SystemPage.esm.js').then((m) => m.SystemPage)
      }
    })
  );
  return {
    plugin,
    CortexPage: CortexPage2,
    EntityCortexContent: EntityCortexContent2,
    CortexScorecardWidget: CortexScorecardWidget2,
    CortexGroupActionItemsWidget: CortexGroupActionItemsWidget2,
    SystemCortexContent: SystemCortexContent2
  };
};
const CortexPage = cortexPlugin.provide(
  createRoutableExtension({
    name: "CortexPage",
    component: () => import('./components/CortexPage/index.esm.js').then((m) => m.CortexPage),
    mountPoint: rootRouteRef
  })
);
const CortexScorecardWidget = cortexPlugin.provide(
  createComponentExtension({
    name: "CortexScorecardWidget",
    component: {
      lazy: () => import('./components/CortexScorecardWidget/index.esm.js').then(
        (m) => m.CortexScorecardWidget
      )
    }
  })
);
const CortexGroupActionItemsWidget = cortexPlugin.provide(
  createComponentExtension({
    name: "CortexGroupActionItemsWidget",
    component: {
      lazy: () => import('./components/CortexGroupActionItemsWidget/index.esm.js').then(
        (m) => m.CortexGroupActionItemsWidget
      )
    }
  })
);
const EntityCortexContent = cortexPlugin.provide(
  createComponentExtension({
    name: "EntityCortexContent",
    component: {
      lazy: () => import('./components/EntityPage/index.esm.js').then((m) => m.EntityPage)
    }
  })
);
const SystemCortexContent = cortexPlugin.provide(
  createComponentExtension({
    name: "SystemCortexContent",
    component: {
      lazy: () => import('./components/SystemPage/SystemPage.esm.js').then((m) => m.SystemPage)
    }
  })
);
const CortexHomepage = cortexPlugin.provide(
  createComponentExtension({
    name: "CortexHomepage",
    component: {
      lazy: () => import('./components/Homepage/Homepage.esm.js').then((m) => m.Homepage)
    }
  })
);

export { CortexGroupActionItemsWidget, CortexHomepage, CortexPage, CortexScorecardWidget, EntityCortexContent, SystemCortexContent, cortexPlugin, extendableCortexPlugin };
//# sourceMappingURL=plugin.esm.js.map
